<template>
    <div class="navigation__outer-wrapper">
        <div v-if="ismobile" class="navigation__wrapper--mobile">
            <div @click="showCarCats = !showCarCats" class="primary-navigation__item--mobile">
                <template v-if="!showCarCats">
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="16"><path d="M38.616 4.772h2.294c.11 0 .22-.025.32-.071l1-.464.215-.1v5.575l-.088.041-3.723 1.725-.15.069-.057-.154-.114-.309a3.67 3.67 0 0 0-3.428-2.39A3.64 3.64 0 0 0 31.4 11.25l-.067.212-.033.106h-.111l-19.443.013h-.111l-.034-.106-.066-.214a3.64 3.64 0 0 0-3.49-2.568 3.638 3.638 0 0 0-3.49 2.573l-.065.214-.034.106h-.111l-1.587.001h-.12l-.028-.117-.964-4.113-.027-.118.108-.053.217-.107C3.35 6.39 5.564 5.9 8.527 5.621a54.99 54.99 0 0 1 4.966-.23c.388 0 .75.004 1.079.013h10.476a.76.76 0 0 0 0-1.518h-7.611l.515-.284 1.696-.938a7.375 7.375 0 0 1 1.905-.74c.96-.22 2.047-.33 3.228-.33 6.264 0 13.463 3.085 13.535 3.116.095.04.196.062.3.062zm-3.73 9.71a2.138 2.138 0 0 1-2.136-2.136c0-1.177.958-2.135 2.135-2.135 1.178 0 2.135.958 2.135 2.135a2.138 2.138 0 0 1-2.135 2.136zm-26.84 0a2.138 2.138 0 0 1-2.136-2.136c0-1.177.958-2.135 2.136-2.135 1.177 0 2.135.958 2.135 2.135a2.138 2.138 0 0 1-2.135 2.136zM24.786.076c-1.3 0-2.503.124-3.572.368a8.877 8.877 0 0 0-2.298.89 242.796 242.796 0 0 0-4.405 2.483l-.073.043-.037.02h-.042l-.084-.001c-.172-.003-.45-.007-.804-.007-2.937 0-10.1.234-13.152 2.407a.758.758 0 0 0-.299.793l1.276 5.448c.081.345.385.586.74.586l2.308-.002h.112l.033.107.066.214A3.638 3.638 0 0 0 8.045 16a3.683 3.683 0 0 0 3.493-2.58l.066-.214.033-.107h.112l19.43-.013h.112l.033.108.066.215A3.682 3.682 0 0 0 34.885 16a3.677 3.677 0 0 0 3.502-2.612l.053-.18.027-.09.092-.016.185-.033a.782.782 0 0 0 .191-.058l4.588-2.125a.761.761 0 0 0 .44-.69V4.029c0-.498-.25-.955-.67-1.222a1.446 1.446 0 0 0-1.389-.092l-1.131.526-.031.014H38.77l-.028-.012-.056-.023C37.417 2.694 30.783.076 24.787.076V0v.076z" fill="#F9BA00" fill-rule="evenodd"/></svg>
                </template>
                <template v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ccd0d7" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs">
                        <line x1="18" y1="6" x2="6" y2="18"/>
                        <line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                </template>
            </div>

            <transition>
                <div v-if="showCarCats" class="steps-navigation">
                    <div class="steps-navigation__container">
                        <div class="navi-steps tri-cta row animate-tri-cta">
                            <div class="col-12 h3">
                                <span class="menu-two__headline">:</span>
                                <span class="visible-xs">{{ $translate("TuningFanatics::Template.carPartsTitle") }}</span>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12 step active">
                                        <div class="select-wrap">
                                            <select  v-model="activeCarL1Cat" :disabled="isLoading">
<!--                                                v-if="carCategories.children"-->
                                                <option selected value="">Marke</option>
                                                <option :value="693">VW</option>
                                                <option :value="662">Audi</option>
                                                <option :value="663">BMW</option>
                                                <option :value="678">Mercedes</option>
                                                <option :value="682">Opel</option>
                                                <option :value="669">Ford</option>
                                                <option :value="687">Seat</option>
                                                <option :value="688">Skoda</option>
                                                <option value="" disabled></option>
                                                <option v-for="cat in carCategories.children" :value="cat.id">{{ cat.details[0].name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 step">
                                        <div class="select-wrap">
                                            <select v-model="activeCarL2Cat" :disabled="isLoading || !activeCarL1Cat">
                                                <option selected value="">Modell</option>
                                                <option v-for="cat2 in carL1Category.children" :value="cat2.id">{{ cat2.details[0].name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 step">
                                        <div class="select-wrap">
                                            <select  v-model="activeCarL3Cat" :disabled="isLoading || !activeCarL2Cat">
                                                <option selected value="">Typ</option>
                                                <option v-for="cat3 in carL2Category.children" :value="cat3.id">{{ cat3.details[0].name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 step last">
                                <button class="menu-two__btn menu-two__btn--mobile" :disabled="isLoading || !activeCarL1Cat" @click="redirectToCat">Finden</button>
                            </div>
                        </div>
                    </div>
                    <div class="steps-navigation__is-loading" v-show="isLoading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
            </transition>
        </div>

        <div v-else class="navigation__wrapper">
            <div class="navigation">
                <div class="primary-navigation">
                    <div class="primary-navigation__container">
                        <div class="primary-navigation__row">
                            <div class="primary-navigation__item">{{ $translate("Ceres::Template.itemCategories") }}&nbsp;<i :class="{'cat-open': showTypeCats}" class="fa fa-angle-down" aria-hidden="true"></i></div>
                            <div @click="showCarCats = !showCarCats; showTypeCats = false" class="primary-navigation__item primary-navigation__item--teile">{{ $translate("TuningFanatics::Template.carPartsTitle") }}&nbsp;<i :class="{'cat-open': showCarCats}" class="fa fa-angle-down" aria-hidden="true"></i></div>
                        </div>
                    </div>
                </div>
                <div v-if="showTypeCats" class="megamenu">
                    <div class="megamenu__left" v-if="typeCategories.children.length">
                        <ul class="megamenu__nav">
                            <li class="megamenu__nav-item" v-for="cat in typeCategories.children" @mouseover="switchActiveTypeCat(cat)">
                                <a class="megamenu__nav-link" :href="'/'+getCategoryUrl(typeCategories.details[0].nameUrl + '/' + cat.details[0].nameUrl)" :title="cat.details[0].name">{{ cat.details[0].name }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="megamenu__right" v-if="typeCategoriesActiveChild.details">
                        <div class="megamenu__sec-headline">{{ typeCategoriesActiveChild.details[0].name }}</div>
                        <ul class="megamenu__sec-nav">
                            <li class="megamenu__sec-nav-item" v-for="catChild in typeCategoriesActiveChild.children">
                                <a class="megamenu__sec-nav-link" :href="'/'+getCategoryUrl(typeCategories.details[0].nameUrl + '/' + typeCategoriesActiveChild.details[0].nameUrl + '/' +  catChild.details[0].nameUrl)" :title="catChild.details[0].name">{{ catChild.details[0].name }}</a>
                            </li>
                        </ul>
                        <a href="https://www.tuning-fanatics.de/geschenkgutscheine/" class="megamenu__newsletter-banner">
                            <lazy-img
                                    picture-class="megamenu__newsletter"
                                    image-url="https://www.tuning-fanatics.de/layout/od_tuning_fanatics_v2/images/gutschein-banner.jpg"
                                    fallback-url="https://www.tuning-fanatics.de/layout/od_tuning_fanatics_v2/images/gutschein-banner.jpg"
                                    alt="Gutschein Banner">
                            </lazy-img>
                        </a>
                    </div>
                </div>
                <transition>
                    <div v-if="showCarCats" class="steps-navigation">
                        <div class="steps-navigation__container">
                            <div class="navi-steps tri-cta row animate-tri-cta">
                                <div class="col-sm-2 h3">
                                    <span class="menu-two__headline">:</span>
                                    <span class="visible-xs">{{ $translate("TuningFanatics::Template.myCar") }}</span>
                                </div>
                                <div class="col-sm-8">
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-4 step active">
                                            <div class="select-wrap">
                                                <select v-if="carCategories.children" v-model="activeCarL1Cat">
                                                    <option selected disabled value="">Marke</option>
                                                    <option :value="693">VW</option>
                                                    <option :value="662">Audi</option>
                                                    <option :value="663">BMW</option>
                                                    <option :value="678">Mercedes</option>
                                                    <option :value="682">Opel</option>
                                                    <option :value="669">Ford</option>
                                                    <option :value="687">Seat</option>
                                                    <option :value="688">Skoda</option>
                                                    <option value="" disabled></option>
                                                    <option v-for="cat in carCategories.children" :value="cat.id">{{ cat.details[0].name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-4 step">
                                            <div class="select-wrap">
                                                <select v-model="activeCarL2Cat" :disabled="isLoading || !activeCarL1Cat">
                                                    <option selected value="">Modell</option>
                                                    <option v-for="cat2 in carL1Category.children" :value="cat2.id">{{ cat2.details[0].name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-4 step">
                                            <div class="select-wrap">
                                                <select  v-model="activeCarL3Cat" :disabled="isLoading || !activeCarL2Cat || !carL2Category.children || carL2Category.children.length < 1">
                                                    <option selected value="">Typ</option>
                                                    <option v-for="cat3 in carL2Category.children" :value="cat3.id">{{ cat3.details[0].name }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-2 step last">
                                    <button class="menu-two__btn" :disabled="isLoading || !activeCarL1Cat" @click="redirectToCat">Finden</button>
                                </div>

                                <div class="steps-navigation__is-loading" v-show="isLoading">
                                    <i class="fa fa-refresh fa-spin"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState } from "vuex";
    import { isNullOrUndefined } from "ceres/app/helper/utils";

    export default {
        props: {
            ismobile: Boolean,
        },
        data() {
            return {
                autoRedirect: true,
                showCarCats: false,
                showTypeCats: false,
                catMenuActive: false,
                megamenuActive: false,
                chunkSize: 12,
                isLoading: false,
                typeCategoriesActiveChild: [],
                activeCarL1Cat: "",
                activeCarL2Cat: "",
                activeCarL3Cat: "",
                carL1Category: {
                    children: []
                },
                carL2Category: {
                    children: []
                },
                carL3Category: {},
          }
        },

        created() {
            this.loadInitialCategories();
        },

        mounted(){
            this.$nextTick(() =>
            {
                this.initMouseObserver();
            });
        },

        methods:
        {
            initMouseObserver(){

                let _this = this;

                $("body").mousemove(function(ev){
                    if($(ev.target).closest('.megamenu').length || $(ev.target).hasClass("megamenu") || ($(ev.target).hasClass('primary-navigation__item') &&
                    !$(ev.target).hasClass("primary-navigation__item--teile"))){
                        _this.showTypeCats = true;
                        _this.showCarCats = false;
                    }else{
                        _this.showTypeCats = false;
                    }
                });
            },

            getCategoryUrl(url)
            {
                const trailingSlash = url[0] === "/" ? "" : "/";
                const prefix = App.urls.includeLanguage ? `/${ App.language }${ trailingSlash }` : "";

                return prefix + url;
            },
            loadInitialCategories()
            {
                if (this.category.length <= 0)
                {
                    this.$store.dispatch("loadPartialNavigationTree", null)
                        .then(response =>
                        {
                            this.$store.commit("setNavigationTree", response);
                        });
                    }
            },
            switchActiveTypeCat(cat){
                if(cat.childCount > 0 && isNullOrUndefined(cat.children)){
                    this.$store.dispatch("loadPartialNavigationTree", cat.id)
                        .then(response =>
                        {
                            const updtCat = response[0].children.find(c => c.id === cat.id);
                            cat.children = updtCat.children;
                            this.typeCategoriesActiveChild = cat;
                        });
                } else {
                    this.typeCategoriesActiveChild = cat;
                }
            },
            fillCatData(cat, isLvl2){
                if (isNullOrUndefined(cat.children) || cat.childCount > cat.children.length){
                    this.isLoading = true;
                    return this.$store.dispatch("loadPartialNavigationTree", cat.id)
                        .then(response =>
                        {
                            console.log(cat.id);
                            console.log(response);
                            const updtCat = isLvl2 ? response[0].children[0].children.find(c => c.id === cat.id) :  response[0].children.find(c => c.id === cat.id);
                            if (!updtCat) throw new Error("cannot find cat");
                            cat.children = updtCat.children;
                            this.isLoading = false;
                            return cat;
                        }).catch(err => {
                            console.log(err);
                            this.isLoading = false;
                            throw err;
                        })
                }
                return Promise.resolve(cat);

            },
            redirectToCat(){
                window.location.href = this.currentUrl;
            }

        },
        computed:
        {
            typeCategories(){
                // Used find instead of fill -> right return type + better performance
                return this.category.find(catTmp => catTmp.id === 659);
            },

            carCategories(){
                return this.category.find(catTmp => catTmp.id === 660);
            },

            currentUrl(){
                if (this.activeCarL3Cat){
                    return this.getCategoryUrl(this.carL3Category.url)
                }
                if (this.activeCarL2Cat){
                    return this.getCategoryUrl(this.carL2Category.url)
                }
                if (this.activeCarL1Cat){
                    return this.getCategoryUrl(this.carL1Category.url)
                }
            },

            ...mapState({
                category: state => state.navigation.tree
            })
        },
        watch: {
            activeCarL1Cat(id, oldId){
                // handle default case
                if (!id) this.carL1Category = { children: []};
                else{
                    // find cat Data and load children if not existing
                    let cat = this.carCategories.children.find(cat => cat.id === id);
                    this.fillCatData(cat)
                        .then(res => this.carL1Category = res)
                        .catch(()=> this.carL1Category = {...cat, children: []});
                }

                // reset selection: l1 -> l2 + l3
                if (id !== oldId){
                    this.activeCarL2Cat = "";
                    this.activeCarL3Cat = "";
                }
            },
            activeCarL2Cat(id, oldId){
                // handle default case
                if (!id) this.carL2Category = { children: []};
                else {
                    // find cat Data and load children if not existing
                    let cat = this.carL1Category.children.find(cat => cat.id === id);
                    this.fillCatData(cat, true)
                        .then(res => this.carL2Category = res)
                        .catch(()=> this.carL2Category = {...cat, children: []})
                        .finally(()=>{
                            // autoRedirect
                            if(this.autoRedirect && (!this.carL2Category.children || this.carL2Category.children.length === 0))
                                window.location.href = this.currentUrl;
                        });
                }

                // reset selection: l2 -> l3
                if (id !== oldId){
                    this.activeCarL3Cat = "";
                }


            },
            activeCarL3Cat(id, oldId){
                // handle default case
                if (!id) this.carL3Category = {};
                else {
                    // set cat Data
                    this.carL3Category = this.carL2Category.children.find(cat => cat.id === id);
                    // autoRedirect
                    if(this.autoRedirect)
                        window.location.href = this.currentUrl;
                }
            }

        },
    }
</script>
